import React from 'react'
import { useParams } from 'react-router-dom'
import { Loader } from '@shared/ui/loader/loader';
import { PostPaymentFail } from '@widgets/payments/ui/post-payment-fail/post-payment-fail';
import { useOrder } from '@features/student/order/api/useOrder';

export const PostPaymentPageFail = () => {
	const {appointmentId} = useParams()
	const { data: order, isLoading} = useOrder(appointmentId)

	const appointment = order?.items[0]?.appointment

  if (isLoading) return <Loader/>;
	
	return <PostPaymentFail teacher_slug={appointment?.teacher?.teacher_slug} orderId={order?.id}/>
}
